module.exports = __webpack_public_path__ + "static/trianglify-f158ddee9c88362cea416b70eda2732e.svg";